import React, { useState, useEffect } from 'react';
import axios from "axios";
import Select from 'react-select';
import ReactDOM from "react-dom";
import Spinner from "../../../Spinner";

const TeacherAidSelect = ({ schoolId, educatorId, selectedTeachers }) => {
  const [teachers, setTeachers] = useState([]);
  const [existingTeachers, setExistingTeachers] = useState([]);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/v1/students/teacher_aids?school_id=${schoolId}&educator_id=${educatorId}`)
      .then((data) => {
        setTeachers(data.data.teachers)
        setExistingTeachers(data.data.existing_aids)
        setSelectedStudentIds(data.data.existing_aids.map(aid => aid.id))
      })
  }, [schoolId, educatorId])

  const handleSubmit = (e) => {
    e.preventDefault();
    $('#students-composite').html('');
    ReactDOM.render(<Spinner color="blue" />, $('#students-composite')[0])

    $.ajax({
      url: `/schools/${schoolId}/add_teacher_aids.js`,
      data: { school_id: schoolId, educator_id: educatorId, student_ids: selectedStudentIds.join(',') },
      type: 'POST',
      dataType: 'script',
    }).then(() => {
      const studentList = $('#students_list');

      if (studentList.length > 0) {
        studentList.html('');
        $.get(`/admin/schools/${schoolId}/composites.js?teacher_id=${educatorId}`, {});
      }

      setExistingTeachers(teachers.filter((option) => selectedStudentIds.includes(option.value)))
    })
  }

  const handleChange = (options) => {
    const ids = options.map((option) => option.value);

    setSelectedStudentIds(ids);
  }

  return (
    <>
    <div className='col-xs-9'>
      <Select
        closeMenuOnSelect={false}
        isMulti
        options={teachers}
        defaultValue={selectedTeachers}
        onChange={(e) => handleChange(e)}
        placeholder="Type a few letters to search"
      />
    </div>

    <div className='col-xs-3'>
      <button className="btn btn-primary" onClick={handleSubmit}>Add aides to classroom</button>
    </div>
    </>
  )
}

export default TeacherAidSelect;
